import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The strange world of getting user data onto a piece of paper",
  "description": "",
  "published": "2011-10-24T00:00:00.000Z",
  "redirect_from": ["/blog/the-strange-world-of-getting-user-data-onto-a-piece-of-paper/swizec/2706"],
  "categories": "Data Formats, Google Docs, Internet meme, Linux, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When was the last time you tried to put something digital onto a piece of paper?`}</p>
    <p>{`It's not very difficult right? As it shouldn't be, we live in the future! Take a document, click print and voila, the magical elves in a plastic box do their magic and you get a lovely piece of paper with some crap on it.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/5059286742_eb649aaae3_m5.jpg",
        "alt": "trollface",
        "title": "trollface"
      }}></img></p>
    <p>{`If you don't have a box of elves of your own, you take it to the nearest person who does, pay them the price of a tenth of gum and they do it for you.`}</p>
    <p>{`But sometimes you want to do this in a more sophisticated manner. Perhaps your target `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Paper_size",
        "title": "Paper size"
      }}>{`paper size`}</a>{` isn't A4, perhaps you're doing something that can't just be whisked up in your favourite Word clone. Maybe, just maybe, you aren't producing the content, maybe you have a form somewhere on the interwebs that people can fill out.`}</p>
    <p>{`As I found out last night and this morning, that bit isn't too simple.`}</p>
    <p>{`Last night I set out on the monumental task of preparing the second batch of `}<a parentName="p" {...{
        "href": "http://postme.me"
      }}>{`Postme.me's`}</a>{` for printing. I was once told that everybody in the world uses something called `}<a parentName="p" {...{
        "href": "http://www.adobe.com/products/indesign/main.html",
        "title": "Adobe InDesign"
      }}>{`InDesign`}</a>{` to do this, hell, I used it to set up the first batch.`}</p>
    <p>{`But it was 18 cards this time, that's a bit much to do by hand isn't it? `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/programmers-are-fucking-lazy/swizec/2648",
        "title": "Programmers are fucking lazy"
      }}>{`I'm a lazy programmer`}</a>{` after all and my kind cowers before menial tasks like nobody's business!`}</p>
    <p><em parentName="p">{`I will automate this!,`}</em>{` I thought.`}</p>
    <p>{`The fuck I will.`}</p>
    <p>{`After spending five minutes getting the database to export as a shiny `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/XML",
        "title": "XML"
      }}>{`XML`}</a>{` I spent upwards of two hours trying to figure out how to convince InDesign to import said XML. Yes, it does haz the capabilities, no they don't help ... or maybe I just can't think like a designer and that's why nothing made sense.`}</p>
    <p>{`I mean come on, you tag all the fields, you get all the data to import and be properly tagged ... but it just does not want to fill the template. It could at least help with the menial tasks. Nope, `}<em parentName="p">{`Fuck you! I will reset all your fonts and colours to a magical default.`}</em>{` Problem?`}</p>
    <p>{`InDesign was trolling me on purpose, I swear!`}</p>
    <p>{`Oh but what's this, browsers have a shiny print to PDF feature don't they? Maybe I can just export as nice `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTML",
        "title": "HTML"
      }}>{`HTML`}</a>{` and get a browser to print it into a PDF and be done with it.`}</p>
    <p>{`Yeah, fuck that too. Turns out no matter how hard I tried it is virtually impossible to convince any browser to print without margins. Even setting up a custom paper size that explicitly defines zero margins ... nope. The closest browser to come to cracking the problem was Chromium on `}<a parentName="p" {...{
        "href": "http://www.kernel.org/",
        "title": "Linux"
      }}>{`Linux`}</a>{` ... things only got screwy around page 15 ... and only got worse henceforth.`}</p>
    <p>{`Chromium on Mac indeed has an actual working marginless feature. But it only supports A4 directly, use the OS's print screen and the marginless feature magically vanishes, but you do get different paper sizes.`}</p>
    <p>{`And it only gets worse.`}</p>
    <p>{`Tried a number of different programs and libraries to export a piece of nicely formatted modern-ish HTML to PDF and nothing worked. Either the paper sizes were off (but the margins were alright) or the font didn't render correctly.`}</p>
    <p>{`In the end, after at least five hours of trying different things, I broke down and did it by hand. Copy pasted all the images and all the text into an InDesign file ...`}</p>
    <p>{`... it took 20 minutes.`}</p>
    <p>{`Hat's off to all the designers of the world who do this stuff on a daily basis.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tc.eserver.org/38079.html"
        }}>{`A Web Developer's Guide To Adobe InDesign`}</a>{` (tc.eserver.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ugliesttattoos.failblog.org/2011/10/23/funny-tattoos-trollface-approved/"
        }}>{`Trollface Approved`}</a>{` (ugliesttattoos.failblog.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://teenwebzine.wordpress.com/2011/05/18/featured-meme-rage-comic-memes/"
        }}>{`Featured Meme: Rage Comic Memes`}</a>{` (teenwebzine.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thegreatflashbang.wordpress.com/2011/10/16/874/"
        }}>{`Trollface`}</a>{` (thegreatflashbang.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=38b6b8c0-faa8-4a03-8cc1-ecbcf3788301",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      